import { render, staticRenderFns } from "./UserFooter.vue?vue&type=template&id=6300b518&"
import script from "./UserFooter.vue?vue&type=script&lang=js&"
export * from "./UserFooter.vue?vue&type=script&lang=js&"
import style0 from "./UserFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports